module.exports = __webpack_public_path__ + "static/makerdao-10f1ffd706e3a89c6559e3eb1c11dbeb.png";